import { ArrowDown2 } from 'iconsax-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useClickAnyWhere } from 'usehooks-ts';
import { type SortFriendReducerFilterType, sortOptions } from '@/hooks/contacts/use-sorted-friends';
import cn from '@/utils/merge-class-names';

type SortContactDropdownProps = {
  sortBy: SortFriendReducerFilterType;
  setSortBy: (value: SortFriendReducerFilterType) => void;
};

const SortContactDropdown = ({ sortBy, setSortBy }: SortContactDropdownProps) => {
  const { t } = useTranslation();
  const dropdownRef = useRef<HTMLDetailsElement>(null);

  const handleUpdateSortBy = (value: SortFriendReducerFilterType) => {
    setSortBy(value);
    if (dropdownRef.current) dropdownRef.current.open = false;
  };

  useClickAnyWhere(() => {
    if (dropdownRef.current && !dropdownRef.current.contains(document.activeElement)) {
      dropdownRef.current.open = false;
    }
  });

  return (
    <details
      ref={dropdownRef}
      className='dropdown dropdown-end dropdown-bottom select-none'>
      <summary className='flex items-center justify-between text-secondary'>
        <span className='pr-0.5 text-body2'>{t(sortOptions.find(({ value }) => value === sortBy)?.label ?? '')}</span>
        <ArrowDown2
          variant='Bold'
          size={8}
        />
      </summary>
      <ul className='menu dropdown-content z-10 mt-1 w-40 rounded-lg bg-neutral-0 p-2 shadow'>
        {sortOptions.map(({ value, label }) => (
          <li
            key={value}
            role='button'
            className={cn(
              'px-4 py-2 text-center text-body1 rounded text-nowrap hover:bg-neutral-100 cursor-pointer',
              sortBy === value && 'bg-neutral-100',
            )}
            onClick={() => handleUpdateSortBy(value)}>
            {t(label)}
          </li>
        ))}
      </ul>
    </details>
  );
};
export default SortContactDropdown;
